import { render, staticRenderFns } from "./PopupDetail.vue?vue&type=template&id=63598902&scoped=true&"
import script from "./PopupDetail.vue?vue&type=script&lang=js&"
export * from "./PopupDetail.vue?vue&type=script&lang=js&"
import style0 from "./PopupDetail.vue?vue&type=style&index=0&id=63598902&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63598902",
  null
  
)

export default component.exports